import { Button } from '@components/ui/button';
import { ComboboxEmpty } from '@components/ui/combobox';
import { InputGroup, InputGroupAddon, InputGroupInput } from '@components/ui/input-group';
import { APP_FOCUS_RING_OVERRIDE } from '@features/query-builder/constants';
import clsx from 'clsx';
import { ChevronLeft, SearchIcon } from 'lucide-react';

export default function SelectorHeader({
  title,
  onBack,
  search,
  setSearch,
}: {
  title: string;
  onBack: () => void;
  search: string;
  setSearch: (search: string) => void;
}) {
  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        className="flex w-full cursor-auto flex-row justify-start gap-1 rounded-none bg-gray-50 has-[>svg]:px-2"
        onClick={onBack}
      >
        <ChevronLeft className="size-4" />
        <p className="text-sm font-medium text-gray-900">Back</p>
      </Button>
      <p className="border-y border-gray-100 bg-gray-50 px-3 py-1 text-xs font-semibold tracking-wide text-gray-500 uppercase">
        {title}
      </p>
      <InputGroup
        className={clsx(
          'border-info-300 h-10 w-full overflow-hidden rounded-none border-x-0 border-y shadow-none',
          APP_FOCUS_RING_OVERRIDE,
        )}
      >
        <InputGroupInput placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} />
        <InputGroupAddon>
          <SearchIcon />
        </InputGroupAddon>
      </InputGroup>
      <ComboboxEmpty>No results found</ComboboxEmpty>
    </>
  );
}
